import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import DashboardType from '../types/DashboardType';

const initialState = {
  balances: [],
  libTimes: [],
  pmSummary: {
    workingOk: 0,
    workingTotal: 0,
    errorList: [],
  },
  cashOut: {
    balance: 0,
    currency: '',
  },
  signUpDetails: [],
  rates: [],
  loadingRates: false,
  voucherSummary: [],
};

export const Dashboard = handleActions(
  {
    [DashboardType.actions.fetchBalancesSuccess]: (currentState, { payload }) => ({ ...currentState, ...payload }),
    [DashboardType.actions.fetchLibTimesSuccess]: (currentState, { payload }) => ({ ...currentState, libTimes: { ...payload } }),
    [DashboardType.actions.fetchPMSummarySuccess]: (currentState, { payload }) => ({ ...currentState, pmSummary: { ...payload } }),
    [DashboardType.actions.fetchSignUpRequestDetailsSuccess]: (currentState, { payload }) => ({ ...currentState, signUpDetails: payload }),
    [DashboardType.actions.fetchCashOutBalanceSuccess]: (currentState, { payload }) => ({
      ...currentState,
      cashOut: {
        balance: payload.cashoutAvailableBalance,
        currency: payload.currency,
      },
    }),
    [DashboardType.actions.fetchExchangeBoard]: (currentState) => ({ ...currentState, loadingRates: true }),
    [DashboardType.actions.fetchExchangeBoardSuccess]: (currentState, { payload }) => ({ ...currentState, rates: payload, loadingRates: false }),
    [DashboardType.actions.fetchVoucherSummarySuccess]: (currentState, { payload }) => ({ ...currentState, voucherSummary: payload }),
  },
  initialState
);

const getDashboard = (state) => state.Dashboard;
export const getNumberOfSubmerchants = createSelector(getDashboard, ({ numberOfSubmerchants }) => numberOfSubmerchants);
export const getBalances = createSelector(getDashboard, ({ balances }) => balances);
export const getLibTimes = createSelector(getDashboard, ({ libTimes }) => libTimes);
export const getPmSummary = createSelector(getDashboard, ({ pmSummary }) => pmSummary);
export const getCashOutBalance = createSelector(getDashboard, (dashboard) => dashboard.cashOut);
export const getHasRolling = createSelector(getDashboard, (dashboard) => dashboard.hasRolling);
export const getHasWallet = createSelector(getDashboard, ({ hasWallet }) => hasWallet);
export const getSignUpRequestDetails = createSelector(getDashboard, (dashboard) => dashboard.signUpDetails);
export const getRatesBoard = createSelector(getDashboard, (dashboard) => dashboard.rates);
export const getVoucherSummary = createSelector(getDashboard, (dashboard) => dashboard.voucherSummary);
export const isLoadingRates = createSelector(getDashboard, (dashboard) => dashboard.loadingRates);
